import moment from "moment";

const VALID_STATUS = "VALID";
const ONLINE_STATUS = "ONLINE";

const NUM_DAYS_BEFORE_EXPIRY_WARNING = 30;

export const checkIsLicenseValidOrOnline = (licenseStatus: string): boolean =>
  licenseStatus === VALID_STATUS || licenseStatus === ONLINE_STATUS;

const isTodayInLastNDaysBeforeDate = (
  nDays: number,
  targetDate: string
): boolean => {
  const nDaysBeforeTargetDate = moment(targetDate).subtract(nDays, "days");

  const today = moment();

  return today.isBetween(nDaysBeforeTargetDate, targetDate);
};

export const isLicenseExpiring = (
  licenseStatus: string,
  licenseExpiryDate: string
): boolean =>
  isTodayInLastNDaysBeforeDate(
    NUM_DAYS_BEFORE_EXPIRY_WARNING,
    licenseExpiryDate
  );

export const formatExpiryDate = (expiryDateUnformatted: string) => {
  const expiryDateMoment = moment.utc(expiryDateUnformatted);
  return expiryDateUnformatted != null && expiryDateMoment.isValid()
    ? expiryDateMoment.format("YYYY-MM-DDTHH:mm:ss[Z]")
    : expiryDateUnformatted;
};
